'use client';

import { Block, Inline } from '@contentful/rich-text-types';
import { useEffect, useState } from 'react';
import Context from '@/services/contentful/pageContext';
import Link from '@/services/contentful/contentTypes/Link';
import Media from '@/services/contentful/contentTypes/Media';
import LinkCRC from '@/components-2.0/contentful/Link/Link';
import MediaCRC from '@/components/contentful/Media';

interface Props {
    node: Block | Inline;
}

type ValidEmbedTypes = 'Link' | 'Media';

export default function InlineEmbed({ node }: Props) {
    const [component, setComponent] = useState(<></>);

    const asset = node.data.target;
    const type: ValidEmbedTypes = asset.sys.contentType?.sys.id;

    useEffect(() => {
        async function parse() {
            let parsed: SiteAsset = {
                cms_id: '',
                cms_type: '',
                fields: {},
            };

            if (type === 'Link') {
                parsed = await Link(asset, {} as Context);
                setComponent(<LinkCRC asset={parsed as SiteLink} />)
            } else if (type === 'Media') {
                parsed = await Media(asset);
                setComponent(<MediaCRC asset={parsed as SiteMedia} />)
            }
        }

        parse();
    }, [asset, type]);

    return component;
}
